/**
 * Turf size labels (live-walk bug 2026-10-19). A turf's member count is PEOPLE; its door count
 * (distinct home addresses, server-computed to match the canvasser walk) is only known on
 * home-address turfs. Never label people as doors.
 */
const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`

export function doorsAndPeople(doors: number | null | undefined, people: number): string {
  const p = plural(people, 'person', 'people')
  return doors == null ? p : `${plural(doors, 'door', 'doors')} · ${p}`
}

/** Total doors across turfs, or null when any turf has no door count (or there are none). */
export function sumDoors(doors: (number | null | undefined)[]): number | null {
  if (doors.length === 0 || doors.some(d => d == null)) return null
  return doors.reduce<number>((total, d) => total + (d as number), 0)
}
